import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '@/views/DashboardView.vue';
import ProfileView from '@/views/ProfileView.vue';
import CredentialsView from '@/views/CredentialsView.vue';
import DeNovoMetastaticColorectalCancerView from '@/views/DeNovoMetastaticColorectalCancerView.vue';
import LungCancerView from '@/views/LungCancerView.vue';
import LungCancerSampleView from '@/views/LungCancerSampleView.vue';
import MultipleMyelomaView from "@/views/MultipleMyelomaView.vue";
import MultipleMyelomaSampleView from "@/views/MultipleMyelomaSampleView.vue";
import FabryView from "@/views/FabryView.vue";
import MyastheniaGravisView from "@/views/MyastheniaGravisView.vue";
import CustomStudiesView from '@/views/CustomStudiesView.vue';
import LandscapingClinicsView from '@/views/LandscapingClinicsView.vue';
import LandscapingDataSourcesView from '@/views/LandscapingDataSourcesView.vue';
import IcdCodeProjectLibraryView from '@/views/IcdCodeProjectLibraryView.vue';
import PharmaPipelinesView from '@/views/PharmaPipelinesView.vue';
import SocialstyrelsenGenericView from '@/views/SocialstyrelsenGenericView.vue';
import SocialstyrelsenGenericDrugsView from '@/views/SocialstyrelsenGenericDrugsView.vue';
import ClinicalTrialsView from '@/views/ClinicalTrialsView.vue';
import VirtualPanelsView from "@/views/VirtualPanelsView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import store from '@/store';

const routes = [
  {
    path: '/',
    name: "Dashboard",
    component: DashboardView,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
    meta: { requiresAuth: true },
  },
  {
    path: '/credentials',
    name: 'Credentials',
    component: CredentialsView,
    meta: { requiresAuth: true },
  },
    {
      path: '/de-novo-metastatic-colorectal-cancer',
      name: 'C18_C19_C20',
      component: DeNovoMetastaticColorectalCancerView,
      meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
    },
  {
    path: '/lung-cancer',
    name: 'C34',
    component: LungCancerView,
    meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
  },
  {
    path: '/lung-cancer-sample',
    name: 'C34sample',
    component: LungCancerSampleView,
    meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
  },
  {
    path: '/multiple-myeloma',
    name: 'C90.0',
    component: MultipleMyelomaView,
    meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
  },
  {
    path: '/multiple-myeloma-sample',
    name: 'C90.0sample',
    component: MultipleMyelomaSampleView,
    meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
  },
  {
    path: '/fabry-disease',
    name: 'E75.2F',
    component: FabryView,
    meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
  },
  {
    path: '/myasthenia-gravis',
    name: 'G70.0',
    component: MyastheniaGravisView,
    meta: { requiresAuth: true, requiresAccessRight: 'patient-level-data', menuKey: 'patient-level-data'},
  },
  {
    path: '/custom-studies',
    name: 'CustomStudies',
    component: CustomStudiesView,
    meta: { requiresAuth: true, requiresAccessRight: 'custom-studies', menuKey: 'custom-studies'}
  },
  {
    path: '/virtual-panels',
    name: 'VirtualPanels',
    component: VirtualPanelsView,
    meta: { requiresAuth: true, requiresAccessRight: ['virtual-panel', 'virtual-panel-admin'], menuKey: 'virtual-panels'}
  },
  {
    path: '/landscaping-clinics',
    name: 'LandscapingClinics',
    component: LandscapingClinicsView,
    meta: { requiresAuth: true, requiresAccessRight: 'data-landscaping', menuKey: 'rwd-landscaping'}
  },
  {
    path: '/landscaping-data-sources',
    name: 'LandscapingDataSources',
    component: LandscapingDataSourcesView,
    meta: { requiresAuth: true, requiresAccessRight: 'data-landscaping', menuKey: 'rwd-landscaping'}
  },
  {
    path: '/icd-code-project-library',
    name: 'IcdCodeProjectLibrary',
    component: IcdCodeProjectLibraryView,
    meta: { requiresAuth: true, requiresAccessRight: 'internal-tools', menuKey: 'internal-tools'}
  },
  {
    path: '/pharma-pipelines',
    name: 'PharmaPipelines',
    component: PharmaPipelinesView,
    meta: { requiresAuth: true, requiresAccessRight: 'internal-tools', menuKey: 'internal-tools'}
  },
  {
    path: '/socialstyrelsen-generic/:icd/:icdPresentation/:icdDescription',
    name: 'SocialstyrelsenGeneric',
    component: SocialstyrelsenGenericView,
    meta: { requiresAuth: true, requiresAccessRight: 'socialstyrelsen-generic', menuKey: 'regional-patient-data'}
  },
  {
    path: '/socialstyrelsen-generic-drugs/:atc/:atcPresentation/:atcDescription',
    name: 'SocialstyrelsenGenericDrugs',
    component: SocialstyrelsenGenericDrugsView,
    meta: { requiresAuth: true, requiresAccessRight: 'socialstyrelsen-generic', menuKey: 'regional-drug-dispensation'}
  },
  {
    path: '/clinical-trials/:mesh/:meshPresentation/:meshDescription',
    name: 'ClinicalTrials',
    component: ClinicalTrialsView,
    meta: { requiresAuth: true, requiresAccessRight: 'clinical-trials', menuKey: 'clinical-trials'}
  },
  {
    path: '/clinical-trials',
    name: 'AllClinicalTrials',
    component: ClinicalTrialsView,
    meta: { requiresAuth: true, requiresAccessRight: 'clinical-trials', menuKey: 'clinical-trials'}
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, _, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({name: 'Dashboard'});
      return;
    }
  }

  if (!to.matched.some(record => record.meta.requiresAccessRight)) {
    next();
    return;
  }

  if (store.getters.stateUser?.access_rights
      && to.matched.every(record => {
        let requiresAccessRight = record.meta.requiresAccessRight
        if (!Array.isArray(requiresAccessRight)) {
          requiresAccessRight = [requiresAccessRight];
        }
        return store.getters.stateUser.access_rights.some(accessRight => requiresAccessRight.includes(accessRight));
      })) {
    next();
  }
});

export default router
